import { getGraphQLApiUrl } from 'additiv-services/setup';
import { createGQContext } from './utils';

export const withCSContext = createGQContext(getGraphQLApiUrl());
